























import { Vue, Prop, Component } from 'vue-property-decorator';

import { ActivityInterface } from '@/interfaces/interfaces';
import { yellowCardIcon, redCardIcon, footballIcon, footballAssistIcon, doubleYellowCardIcon } from '@/assets/images';

@Component
export default class FutsalActivitivist extends Vue {
  @Prop() private teamType!: string;
  @Prop() private playerName!: string;
  @Prop() private activityType!: string;

  private redCardIcon: string = redCardIcon;
  private footballIcon: string = footballIcon;
  private yellowCardIcon: string = yellowCardIcon;
  private footballAssistIcon: string = footballAssistIcon;
  private doubleYellowCardIcon: string = doubleYellowCardIcon;
}
